import React from "react";
import { RightOutlined } from "@ant-design/icons";
import { Button } from "antd";

function Postmention() {
  return (
    <div className="container">
      <div className="bg-[#9AD7D2] rounded-3xl py-20 flex justify-center items-center my-16">
        <div className="text-center">
          <h2 className="text-white text-3xl font-semibold font-outfit mb-8  font-custom">
            Ready To Create Some <br /> Custom Products?
          </h2>
          <Button
            type="default"
            className="bg-white m-auto block text-[#7CCDC5] font-semibold text-center flex items-center px-8 py-5 h-auto rounded-full border-none text-base flex items-center justify-center hover:bg-[#7CCDC5] hover:text-white transition-all duration-300"
          >
            Explore More
            <RightOutlined className="ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Postmention;
